"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkingTimeTypeSelect = void 0;
var WorkingTimeTypeSelect_1 = require("./WorkingTimeTypeSelect");
Object.defineProperty(exports, "WorkingTimeTypeSelect", { enumerable: true, get: function () { return WorkingTimeTypeSelect_1.WorkingTimeTypeSelect; } });
